import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import UserService from "../services/user.service";
import OrderService from "../services/order.service";
import Form from "react-bootstrap/Form";
import Card from "react-bootstrap/Card";
import Spinner from "react-bootstrap/Spinner";
import Button from "react-bootstrap/Button";
import { submittedOrder, updatedBalance, clearCart, getCurrentOrder } from '../reducers/cart';
import { getUser, reloadUser } from '../reducers/auth';
import Table from 'react-bootstrap/Table';
import { Navigate, useLocation } from "react-router-dom";


const Confirm = () => {
    const apiUrl = process.env.REACT_APP_LOCALHOST_URL;
    const { state } = useLocation();
    const [order, setOrder] = useState(null);
    const user = useSelector(getUser);
    const dispatch = useDispatch();

    useEffect(() => {
        console.log("ORDER ID", state);
        async function fetchData() {
            const newOrder = await OrderService.getOrder(state.orderId);
            console.log("ORDER", newOrder);
            setOrder(newOrder);
            dispatch(clearCart());
            dispatch(getCurrentOrder());
            dispatch(reloadUser());
        }
        fetchData();
    }, []);

    const formatPantsSize = (sizeName) => {
        var isFour = /^\d{4}$/.test(sizeName);
        if (isFour) {
            return sizeName.substring(0, 2) + "x" + sizeName.substring(2);
        } else {
            return sizeName;
        }
    }

    let totalCount = 0;
    return (
        <div className="container">
            {order && (

                <div class="checkout-container">
                    <h2>Order # {order.id} </h2>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                        <h2>Delivering to {order.deliveryName}</h2>
                        <div style={{ marginLeft: 30, padding: 5, border: "1px solid #CCCCCC" }}>{order.deliveryAddress}<br />
                            {order.deliveryAddress2 != null && order.deliveryAddress2 != "" && <>{order.deliveryAddress2}<br /></>}
                            {order.deliveryCity}, {order.deliveryState} {order.deliveryZip}<br />
                        </div>
                    </div>
                    <div class="review-container">
                        <h2>Items</h2>

                        <div class="content">
                            <div class="cart-item-container">
                                <div class="price-label">PRICE</div>
                                {order && order.order_items && order.order_items.map(item => {
                                    totalCount += item.quantity;
                                    return (
                                        <div class="cart-item">
                                            <div style={{ position: "relative", width: "150px" }}>
                                                <img className="bg-image" src={item.product.frontModelImage} width={150}></img>
                                                {item.decorations && item.decorations.map((logo, i) => (
                                                    <img className="logo-image" src={apiUrl + logo.imageUrl} width={logo.width + '%'} style={{ left: logo.x + '%', top: logo.y + '%', transform: 'rotate(' + logo.rotate + 'deg)' }}></img>
                                                )
                                                )}

                                            </div>

                                            <div class="content">
                                                <div class="title">{item.product.style.title}</div>
                                                <div class="color">Color: {item.colorName}</div>
                                                <div class="size-name">Size: {formatPantsSize(item.sizeName)}</div>
                                                <div class="quantity">Quantity: {item.quantity}</div>
                                                <div>
                                                    {item.subsite_decorations?.map(logo => {
                                                        console.log("LOGO IN DECORATION", logo);
                                                        return logo.decoration_logo.decorationName + " - " + logo.deco_location.description;
                                                    })}
                                                </div>
                                            </div>
                                            <div class="total">{(item.price * item.quantity).toLocaleString(undefined, { style: "currency", currency: "USD" })}</div>
                                        </div>
                                    );
                                })
                                }
                                <div class="total">Shipping: <strong>{(order.shippingCost ? order.shippingCost : 0).toLocaleString(undefined, {
                                    style: "currency",
                                    currency: "USD",
                                })}</strong></div>
                                {order.paymentType === "balance" || order.paymentType === "split" &&
                                    <div class="total">Balance Used: <strong style={{ color: "#990000" }}>({(order.balanceUsed ? order.balanceUsed : 0).toLocaleString(undefined, {
                                        style: "currency",
                                        currency: "USD",
                                    })})</strong></div>}
                                <div class="total">Total: <strong>{(order.orderCost - order.balanceUsed ? order.orderCost - order.balanceUsed : 0).toLocaleString(undefined, {
                                    style: "currency",
                                    currency: "USD",
                                })}</strong></div>
                            </div>
                        </div>

                    </div>
                    <div></div>
                </div>
            )}
        </div>
    );
};
export default Confirm;